// Sign-in page. The app has no passwords: the button goes to Cognileap identity (OpenID Connect),
// which sends the browser back to /auth/callback.
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { api } from '../lib/api';

export function Login() {
  const [params] = useSearchParams();
  const [configured, setConfigured] = useState<boolean | null>(null);
  const error = params.get('error');
  const message = params.get('message');
  const account = params.get('account');
  const returnTo = params.get('return_to') ?? '/';
  const safe = returnTo.startsWith('/') && !returnTo.startsWith('//') && !returnTo.startsWith('/login') ? returnTo : '/';

  useEffect(() => {
    document.title = 'Sign in · Cognibrain';
    api<{ configured: boolean }>('/api/auth/config', { noRedirect: true })
      .then((r) => setConfigured(r.configured))
      .catch(() => setConfigured(null));
  }, []);

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <span className="dot" style={{ background: '#0e7490' }} aria-hidden="true" />
          <span className="dot" style={{ background: '#6d28d9' }} aria-hidden="true" />
          <span className="dot" style={{ background: '#b45309' }} aria-hidden="true" />
        </div>
        <h1>Cognibrain</h1>
        <p className="muted">Two private companies, one deliberate collaboration space.</p>
        {error && (
          <p className="msg err" role="alert">
            {message || `Sign-in failed (${error}).`}
          </p>
        )}
        {error && account && (
          <a className="btn primary block" href={`/auth/login?switch=1&return_to=${encodeURIComponent(safe)}`}>
            Use another account
          </a>
        )}
        {configured === false ? (
          <p className="msg warn" role="status">
            Sign-in is not configured on this server yet (OIDC settings missing). An administrator needs to connect it to
            Cognileap identity.
          </p>
        ) : (
          <>
            <a
              className={`btn block ${error && account ? '' : 'primary'}`}
              href={`/auth/login?return_to=${encodeURIComponent(safe)}`}
            >
              Sign in with Cognileap
            </a>
            {!(error && account) && (
              <a className="link small center-text" href={`/auth/login?switch=1&return_to=${encodeURIComponent(safe)}`}>
                Sign in with a different account
              </a>
            )}
          </>
        )}
        <p className="muted small">
          You sign in at id.cognileap.app with the e-mail you were invited with. This app never sees your password.
        </p>
      </div>
    </div>
  );
}
